import { gql } from '@apollo/client';

export const GET_LOCATION_SUGGESTIONS = gql`
  query GET_LOCATION_SUGGESTIONS(
    $query: String!
    $biasLatitude: Float
    $biasLongitude: Float
  ) {
    locationSuggestions(
      query: $query
      biasLatitude: $biasLatitude
      biasLongitude: $biasLongitude
    ) {
      name
      address
      city
      state
      latitude
      longitude
      placeId
    }
  }
`;
